import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { variantFilter } from './Reducers/Rutab/VariantFilter.reducer';
import { mediaFolderExplorer } from './Reducers/Rutab/MediaFolderExplorer.reducer';
import { checkoutRelatedItems } from './Reducers/Rutab/RutabCheckout.RelatedItems.reducer';
import { decalEditor } from './Reducers/Rutab/decalEditor.reducer';
import { decalEditorAPI } from './Reducers/Rutab/decalEditorAPI.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    variantFilter,
    mediaFolderExplorer,
    checkoutRelatedItems,
    decalEditor,
    decalEditorAPI,
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
